import { render, staticRenderFns } from "./LocationsSelect.vue?vue&type=template&id=01e422e2&lang=pug&"
import script from "./LocationsSelect.vue?vue&type=script&lang=js&"
export * from "./LocationsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports